module.exports = __webpack_public_path__ + "static/img/default.c1ce2b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default.png
// module id = jY2U
// module chunks = 13